export const LogoIcon = ({
  theme = null,
  width = null,
  height = null,
}: {
  theme?: 'black' | 'blue' | 'white' | 'blue-text' | null;
  width?: string | null;
  height?: string | null;
}) => {
  switch (theme) {
    case 'black':
      return (
        <img
          crossOrigin="anonymous"
          src="https://cdn.1cdn.app/application/LOUISEBOT/23091707385730_Logo_Black.svg"
          width={width ? width : '32px'}
          height={height ? height : '32px'}
          alt="LouiseBot Logo"
        />
      );
    case 'white':
      return (
        <img
          crossOrigin="anonymous"
          src="https://cdn.1cdn.app/application/LOUISEBOT/23091707385785_Logo_White.svg"
          width={width ? width : '32px'}
          height={height ? height : '32px'}
          alt="LouiseBot Logo"
        />
      );
    case 'blue':
      return (
        <img
          crossOrigin="anonymous"
          src="https://cdn.1cdn.app/application/LOUISEBOT/23091707385795_Logo_colorful.svg"
          width={width ? width : '32px'}
          height={height ? height : '32px'}
          alt="LouiseBot Logo"
        />
      );
    case 'blue-text':
      return (
        <img
          crossOrigin="anonymous"
          src="https://cdn.1cdn.app/application/LOUISEBOT/24020310415492_Logo-Type.svg"
          width={width ? width : 'auto'}
          height={height ? height : '32px'}
          alt="LouiseBot Logo"
        />
      );
    default:
      return (
        <img
          crossOrigin="anonymous"
          src="https://cdn.1cdn.app/application/LOUISEBOT/23091707385785_Logo_White.svg"
          width={width ? width : '32px'}
          height={height ? height : '32px'}
          alt="LouiseBot Logo"
        />
      );
  }
};
